var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.2929 12L1.64647 21.6464L2.35358 22.3535L12 12.7071L21.6464 22.3535L22.3535 21.6464L12.7071 12L22.3536 2.35356L21.6464 1.64645L12 11.2929L2.35355 1.64645L1.64645 2.35356L11.2929 12Z",
  fill: "#A2A9AD"
})));
export { SvgCloseThin as ReactComponent };
export default __webpack_public_path__ + "images/close-thin.svg";